import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconThumbSvg } from "./IconThumbSvg.mjs";
import { root, down } from "./IconThumb.css.mjs";
const IconThumb = ({ direction = "up", ...props }) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: ({ className, ...svgProps }) => /* @__PURE__ */ jsx(
  Box,
  {
    component: IconThumbSvg,
    className: [
      root,
      className,
      {
        [down]: direction === "down"
      }
    ],
    ...svgProps
  }
) });
export {
  IconThumb
};
